import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const partnerApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/partner",
      params,
    }),
  findOptions: (params?: { search?: string }): AxiosPromise<any> =>
    request({
      url: "/v1/admin/partner/options",
      params,
    }),
  findOne: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/partner/${id}`,
    }),
  findCustomers: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/partner/${id}/customers`,
    }),
  create: (data: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/partner",
      data,
      method: "post",
    }),
  update: (id: number, data: any): AxiosPromise<any> =>
    request({
      url: `/v1/admin/partner/${id}`,
      method: "patch",
      data,
    }),
  delete: (id: number): AxiosPromise<any> =>
    request({
      url: `/v1/admin/partner/${id}`,
      method: "delete",
    }),
};
